import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { PayrollCycle } from "../../types/User";

export const getMyEmployerPayrollCycles = () => {
  const { fetchWithAuth } = useApi();
  return useQuery(["employer-payroll-cycles"], (): Promise<PayrollCycle[]> => {
    return fetchWithAuth<PayrollCycle[]>("getMyEmployerPayrollCycles");
  });
};
